// extracted by mini-css-extract-plugin
export var actions = "_mn-d";
export var benefitCard = "_mn-a";
export var benefitIcon = "_mn-b";
export var benefitLabel = "_mn-c";
export var benefits = "_mn-9";
export var bodyText = "_mn-8";
export var closeButton = "_mn-2";
export var content = "_mn-3";
export var eyebrow = "_mn-4";
export var heading = "_mn-5";
export var image = "_mn-f";
export var imagePanel = "_mn-e";
export var modal = "_mn-0";
export var shell = "_mn-1";
export var title = "_mn-6";
export var titleOffer = "_mn-7";